import { render, staticRenderFns } from "./rpterctstdprenotconfirm.vue?vue&type=template&id=00673612&"
import script from "./rpterctstdprenotconfirm.vue?vue&type=script&lang=js&"
export * from "./rpterctstdprenotconfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports